/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../hooks/useAuthorizedEpApps';
import config from '../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import GLRetantionDashboard from '../../components/GLP2PAdvComp/GLRetantion/GLRetantionDashboard';
import GLRetantionChart from '../../components/GLP2PAdvComp/GLRetantion/GLRetantionChart';
import TabSwitcher from '../../components/FileUploadComp/TabSwitcher/TabSwitcher';
import styles from './GLRetantionPage.module.css';
import { saveLogToBackend } from '../../api';

const GLRetantionPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();
  const history = useHistory();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);

  const logData = {
    username: localStorage.getItem("preferred_username") || "anonymous",
    page: window.location.pathname,
    method: "PAGE_VISIT",
    url: window.location.href,
    status: "SUCCESS",
    duration: 0,
    timestamp: new Date().toISOString(),
  };

  useEffect(() => {
    saveLogToBackend(logData);
  }, []);

  const [selectedTab, setSelectedTab] = useState('Retention GL Trend');

  const availableTabs = ['Retention GL Trend', 'Retention GL Summary Report'];

  const handleBack = () => {
    history.push("/Procure-To-Pay/Account-Payable");
  };

  return (
    <div className={styles.container}>
      <div className={styles.tabHeader}>
        <TabSwitcher
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabs={availableTabs}
        />
        <button className={styles.backButton} onClick={handleBack}>
          ← Back
        </button>
      </div>
      {
      selectedTab === 'Retention GL Trend' ? (
        <GLRetantionChart />
      ) :
       selectedTab === 'Retention GL Summary Report' ? (
        <GLRetantionDashboard />
      ) : null}
    </div>
  )
}

GLRetantionPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(GLRetantionPage);
